import { Alert, Button } from '@ksyos/design-system';
import { sortBy } from 'lodash';
import { useState } from 'react';
import type { ServiceCode } from '../../../common/enums/serviceCode';
import { getServiceLabel } from '../../../common/customControls/getServiceLabel';
import { serviceCodeButtonOrder } from '../../../common/customControls/ggzConsultServiceCodeSortOrder';
import { translateKey } from '../../translate';
import { Form, FormLabel, InputRadioGroup } from './common';
import { HorizontalFormGroup } from './forms/HorizontalFormGroup';
import { InputContainer } from './forms/InputContainer';
import { Modal } from './modals/Modal';

interface IService {
    code: ServiceCode;
    id: string;
    name: string;
}

interface IChangeToServiceModalProps {
    closeModal: () => void;
    isOpen: boolean;
    onChangeService: (consultServiceId: string) => Promise<void>;
    services: IService[];
}

export function ChangeToServiceModal(props: IChangeToServiceModalProps) {
    const [serviceId, setServiceId] = useState<string | null>(null);

    const sortedServices = sortBy(props.services, (service) => serviceCodeButtonOrder.indexOf(service.code));

    const servicesWithLabels = sortedServices.map((item) => ({
        label: getServiceLabel(item.code, 'request', item.name),
        id: item.id,
    }));

    return (
        <Modal
            actionButtons={[
                <Button
                    onClick={props.closeModal}
                    variant="outline"
                >
                    {translateKey('common.cancel')}
                </Button>,
                <Button
                    className="automation-change"
                    isDisabled={!serviceId}
                    onClick={async () => await props.onChangeService(serviceId!)}
                >
                    {translateKey('request.change')}
                </Button>,
            ]}
            isOpen={props.isOpen}
            onClose={props.closeModal}
            size="large"
            title={translateKey('request.changeConsultType')}
        >
            <Alert appearance="info">
                Heb je de vraag van de huisarts al op een andere manier beantwoord? Wijzig dan het consulttype.
            </Alert>
            <Form onSubmit={async () => null}>
                <HorizontalFormGroup>
                    <FormLabel>{translateKey('request.statusAction_changeService')}</FormLabel>
                    <InputContainer>
                        <InputRadioGroup
                            labels={servicesWithLabels.map((item) => item.label)}
                            name="consultType"
                            onChange={async (value) => setServiceId(value)}
                            options={servicesWithLabels.map((item) => item.id)}
                            value={serviceId}
                        />
                    </InputContainer>
                </HorizontalFormGroup>
            </Form>
        </Modal>
    );
}
